import React, {Component} from 'react';
import EditSelectionView from "./EditSelectionView";
import {Growl} from "primereact/growl";
import Typography from "@material-ui/core/Typography";
import {CatalogService} from "../../../../service/catalog/CatalogService";
import {GuaranteeSelectionService} from "../../../../service/limitControl/GuaranteeSelectionService";


export default class EditSelectionContainer extends Component {
    /**
     * Constructor de la clase, se inicializan las variables.
     * Se toma el elemento a editar que viene de la pantalla anterior.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     *              Trae el elemento de la pantalla anterior para editar.
     */
    constructor(props) {
        super(props);
        this.catalogService = new CatalogService();
        this.guaranteeSelectionService = new GuaranteeSelectionService();
        this.getGuaranteesAvailables = this.getGuaranteesAvailables.bind(this);

        this.state = {
            returnPath: this.props.location.state.returnPath,
            sourceGuarantees: this.getGuaranteesAvailables(),
            targetGuarantees: this.props.location.state.guaranteesSelected,
            guaranteesList: [],
            isLoading: false,
        };

        this.returnGuaranteeSelection = this.returnGuaranteeSelection.bind(this);
        this.guaranteesTemplate = this.guaranteesTemplate.bind(this);
        this.onChangePickList = this.onChangePickList.bind(this);
        this.saveGuaranteesSelection = this.saveGuaranteesSelection.bind(this);
        this.loading = this.loading.bind(this);

    }

    getGuaranteesAvailables() {
        this.loading(true);
        this.catalogService.getCatalogValues()
            .then(res => {
                this.setState({
                    targetGuarantees: this.props.location.state.guaranteesSelected,
                    sourceGuarantees: res,
                });
                this.loading(false);
            });
    }

    guaranteesTemplate(guarantee) {
        return (
            <div className="p-clearfix">
                <Typography variant="subtitle2" gutterBottom style={{fontWeight: "bolder"}}>
                    {guarantee.nombre}
                </Typography>
            </div>
        );
    }

    onChangePickList(event) {
        this.setState({
            sourceGuarantees: event.source,
            targetGuarantees: event.target
        });
    }

    saveGuaranteesSelection() {
        this.loading(true);
        let targetProcessAux = this.state.targetGuarantees;
        let processListStr = "";
        targetProcessAux.forEach(item => {
            processListStr = processListStr.concat("|" + item.id + "," + item.tipo);
        });
        processListStr = processListStr.substring(1);
        this.guaranteeSelectionService.modifyGuaranteesValues(processListStr)
            .then(res => {
                if (res.message === "Success") {
                    let message = {};
                    message['severity'] = 'success';
                    message['summary'] = 'Éxito.';
                    message['detail'] = 'Las restricciones han sido modificadas exitosamente';
                    this.returnGuaranteeSelection(message);
                } else {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: res.error
                    });
                }
            });
        this.loading(false);
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false,
            });
        }
    }


    /**
     * Función que regresa a la pantalla de Captura de Garantías
     */
    returnGuaranteeSelection(message) {
        this.setState({isLoading: false,});
        this.props.history.push({
            pathname: this.state.returnPath,
            message: message,
        });
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {sourceGuarantees, isLoading, targetGuarantees} = this.state;

        return (
            <EditSelectionView
                sourceGuarantees={sourceGuarantees}
                messagesGrowl={messagesGrowl}
                isLoading={isLoading}
                targetGuarantees={targetGuarantees}
                guaranteesTemplate={this.guaranteesTemplate}
                onChangePickList={this.onChangePickList}
                saveGuaranteesSelection={this.saveGuaranteesSelection}
                loading={this.loading}
                returnGuaranteeSelection={this.returnGuaranteeSelection}
            />
        );
    }
}
